import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useRegion } from '@/hooks/useRegion';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

/** Navbar'dagi viloyat tanlovi. Qiymat `region` search param'ida saqlanadi —
 *  sahifalar uni API'ga `region_code` bo'lib uzatadi. */
export const RegionSelect = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const { data: regions } = useRegion();

  const value = searchParams.get('region') || 'all';

  const handleChange = (next: string) => {
    setSearchParams((prev) => {
      if (next === 'all') prev.delete('region');
      else prev.set('region', next);
      /** Viloyat almashsa tuman tanlovi kuchini yo'qotadi. */
      prev.delete('district');
      return prev;
    });
  };

  return (
    <Select value={value} onValueChange={handleChange}>
      <SelectTrigger className="h-10 w-[190px] rounded-lg border-border bg-card text-foreground">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">{t('all_regions')}</SelectItem>
        {regions?.map((region) => (
          <SelectItem key={region.value} value={region.value}>
            {region.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
